import React from 'react'

import s from './styles.module.scss'

import Scrollbars from '../scrollbars/scrollbars'
import { Icon } from '../../atoms'

export const Card = ({
  title,
  children,
  className,
  style = {},
  isScrolling = false,
  isCollapsible = false,
  isOpened = true,
  styleContent = {},
  toggleCard,
  styleTitle = {},
}: {
  title?: React.ReactNode
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  styleContent?: React.CSSProperties
  isScrolling?: boolean
  isCollapsible?: boolean
  isOpened?: boolean
  toggleCard?: () => void
  styleTitle?: React.CSSProperties
}) => {
  const classNames = () => {
    let classes = s.container
    if (className) {
      classes += ` ${className}`
    }
    if (isCollapsible) {
      classes += ` ${s.collapsible}`
    }
    if (!isOpened) {
      classes += ` ${s.collapse}`
    }

    return classes
  }

  const renderContent = () => {
    return (
      <>
        {title &&
          (typeof title === 'string' ? (
            <h2 className={s.title} style={styleTitle}>
              {title}
              {isCollapsible && (
                <Icon
                  name='arrow-down'
                  size={12}
                  className={s.arrowIcon}
                  onClick={() => toggleCard && toggleCard()}
                />
              )}
            </h2>
          ) : (
            <>{title}</>
          ))}
        <div className={s.content} style={styleContent}>
          {children}
        </div>
      </>
    )
  }

  if (isScrolling) {
    return (
      <Scrollbars
        className={classNames()}
        style={{ border: '1px solid var(--border)' }}
      >
        {renderContent()}
      </Scrollbars>
    )
  }

  return (
    <div className={classNames()} style={{ ...style, border: style.border }}>
      {renderContent()}
    </div>
  )
}
